/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planvereinsdescription3Inputs */

const en_planvereinsdescription3 = /** @type {(inputs: Planvereinsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For clubs and student groups`)
};

const de_planvereinsdescription3 = /** @type {(inputs: Planvereinsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Vereine und Hochschulgruppen`)
};

/**
* | output |
* | --- |
* | "For clubs and student groups" |
*
* @param {Planvereinsdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planvereinsdescription3 = /** @type {((inputs?: Planvereinsdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planvereinsdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planvereinsdescription3(inputs)
	return de_planvereinsdescription3(inputs)
});
export { planvereinsdescription3 as "planVereinSDescription" }